import axios from 'axios';

const getList = params => axios.get('/tipos-uso', {
  params,
});
const get = id => axios.get(`/tipos-uso/${id}`, {});

const save = (tiposUso) => {
  if (tiposUso.id) {
    return axios.put(`/tipos-uso/${tiposUso.id}`, tiposUso);
  }
  return axios.post('/tipos-uso', tiposUso);
};

const remover = id => axios.delete(`/tipos-uso/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
